import type { WWindowBannerTranslations } from "./pl";

export const en: WWindowBannerTranslations = {
  empty: "No banners to display.",
  goToSlide: (index: number): string => `Go to banner ${index}`,
  bannerAlt: "Banner",
  close: "Close",
};
